'use strict';

angular.module('completeAir.module.directive', [])
    .directive("capitalizeFirst", ['$parse', function( $parse){
        return {

            require: 'ngModel',
            link: function(scope, element, attrs, modelCtrl) {
                var capitalize = function(inputValue) {
                    if (inputValue === undefined || inputValue === null) { inputValue = ''; }
                    var capitalized = inputValue.charAt(0).toUpperCase() +
                        inputValue.substring(1);
                    if(capitalized !== inputValue) {
                        modelCtrl.$setViewValue(capitalized);
                        modelCtrl.$render();
                    }
                    return capitalized;
                }
                modelCtrl.$parsers.push(capitalize);
                capitalize($parse(attrs.ngModel)(scope));
            }
        }
    }])
    .directive("capitalize", ['$parse', function( $parse){
        return {
            require: 'ngModel',
            link: function(scope, element, attrs, modelCtrl) {
                var capitalize = function(inputValue) {
                    if (inputValue === undefined || inputValue === null) { inputValue = ''; }
                    var capitalized = inputValue.toUpperCase();
                    if(capitalized !== inputValue) {
                        modelCtrl.$setViewValue(capitalized);
                        modelCtrl.$render();
                    }
                    return capitalized;
                }
                modelCtrl.$parsers.push(capitalize);
                capitalize($parse(attrs.ngModel)(scope));
            }
        }
    }])
    .directive('loadingOverlay', [function(){

        function link(scope, element, attrs){
            var ele = $(element),
                eleImg = '<div class="img-loader"></div>';
            ele.html(eleImg)
        }

        return {
            link: link
        }
    }])
    .directive('scrollBar', [function(){

        function link(scope, element, attrs){
            var ele = $(element),
                eleFind = ele.find('.content-scroll-bar');
            attrs.$observe("scrollBar", function(value){
                var jsonValue = eval ("(" + value + ")");
                ele.css({'height': (jsonValue.height + 20) + 'px'});
                eleFind.css({'height': jsonValue.height + 'px'});
            });
        }

        return {
            link: link
        }
    }])
    .directive('wizardSteps', ['$rootScope', '$timeout', function($rootScope, $timeout){
        function link(scope, element, attrs){
            var eleWizard = $(element),
                targetId = attrs.id,
                formAction = attrs.formAction;

            var formValidate, nextPreviousActive, stateWizardTabs, stateWizard;

            $timeout(function(){
                eleWizard.bootstrapWizard({
                    tabClass: 'nav nav-pills',
                    onInit: function(tab, navigation, index){
                        var wizardAllTabs = navigation.find('li'),
                            tabCount = wizardAllTabs.length,
                            percentDone = 100 / tabCount;

                        wizardAllTabs.css({width:percentDone+'%'});
                        stateWizardTabs(wizardAllTabs);
                    },
                    onTabClick: function(tab, navigation, index){
                        return false;
                    },
                    onPrevious: function(tab, navigation, index) {
                        var indexTab = index + 1;
                        nextPreviousActive(indexTab);
                    },
                    onNext: function(tab, navigation, index) {
                        var indexTab = index + 1;
                        $timeout(function(){
                            var previousForm = $('#' + 'tab' + index + ' > form'),
                                isValidForm = formValidate(previousForm);

                            if(!isValidForm){
                                stateWizard(tab, 'remove');
                                eleWizard.bootstrapWizard('previous');
                                return false;
                            }else{
                                nextPreviousActive(indexTab);
                                stateWizard(tab, 'add');
                            }
                        }, 100);
                    }
                });
            }, 10);

            formValidate = function(form){
                var errorMsg = form.find('.error-msg'),
                    res = false;

                if(errorMsg.length == 0){
                    res = true;
                }
                return res;
            }

            nextPreviousActive = function(index){
                $("#" + targetId + " .tab-content .tab-pane").removeClass('active');
                $("#tab" + index).addClass("active");
            }

            stateWizardTabs = function(wizardAllTabs){
                if(formAction == 'update'){
                    angular.forEach(wizardAllTabs, function(index, key){
                        stateWizard(angular.element(index), 'add')
                    });
                }
            }

            stateWizard = function(ele, type){
                if(type == 'add'){
                    ele.addClass('wizard-active');
                }else{
                    ele.removeClass('wizard-active');
                }
            }
        }
        return {
            link: link
        }
    }])
    .directive('compareTo',function() {
        return {
            require: "ngModel",
            scope: {
                otherModelValue: "=compareTo"
            },
            link: function(scope, element, attributes, ngModel) {

                ngModel.$validators.compareTo = function(modelValue) {
                    return modelValue == scope.otherModelValue;
                }

                scope.$watch("otherModelValue", function() {
                    ngModel.$validate();
                });
            }
        }
    })
    .directive('validateAlphaNumeric', [function(){
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, element, attributes, ngModel) {
                var regex = '/^[a-zA-Z0-9]*$/';
                var eleJQuery = $(element);

                eleJQuery.attr('ng-pattern', regex);
                eleJQuery.attr('ng-pattern-err-type', 'alphaNumeric');
            }
        }
    }])
    .directive("letterSpace", ['$parse', function($parse){
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {
                var validateNumber = function (inputValue) {
                    if (inputValue === undefined) {
                        return '';
                    }
                    var transformedInput = inputValue.replace(/[^a-zA-Z ]/g, '');
                    //var transformedInput = inputValue.replace(//g, '');
                    if (transformedInput !== inputValue) {
                        ctrl.$setViewValue(transformedInput);
                        ctrl.$render();
                    }
                    return transformedInput;
                };

                ctrl.$parsers.unshift(validateNumber);
                ctrl.$parsers.push(validateNumber);
                attrs.$observe('notEmpty', function () {
                    validateNumber(ctrl.$viewValue);
                });
            }
        }
    }])
    .directive("letterSpaceHyphen", ['$parse', function($parse){
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {
                var validateNumber = function (inputValue) {
                    if (inputValue === undefined) {
                        return '';
                    }
                    var transformedInput = inputValue.replace(/[^a-zA-Z \s-]/g, '');
                    //var transformedInput = inputValue.replace(//g, '');
                    if (transformedInput !== inputValue) {
                        ctrl.$setViewValue(transformedInput);
                        ctrl.$render();
                    }
                    return transformedInput;
                };

                ctrl.$parsers.unshift(validateNumber);
                ctrl.$parsers.push(validateNumber);
                attrs.$observe('notEmpty', function () {
                    validateNumber(ctrl.$viewValue);
                });
            }
        }
    }])
    .directive("numberSpace", ['$parse', function($parse){
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {
                var validateNumber = function (inputValue) {
                    if (inputValue === undefined) {
                        return '';
                    }
                    var transformedInput = inputValue.replace(/[^0-9 ]/g, '');
                    if (transformedInput !== inputValue) {
                        ctrl.$setViewValue(transformedInput);
                        ctrl.$render();
                    }

                    return transformedInput;
                };

                ctrl.$parsers.unshift(validateNumber);
                ctrl.$parsers.push(validateNumber);
                attrs.$observe('notEmpty', function () {
                    validateNumber(ctrl.$viewValue);
                });
            }
        }
    }])
    .directive("letterNumberSpaceHyphen", ['$parse', function($parse){
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {
                var validateNumber = function (inputValue) {
                    if (inputValue === undefined) {
                        return '';
                    }
                    var transformedInput = inputValue.replace(/[^a-zA-Z-0-9 \s-]/g, '');
                    //var transformedInput = inputValue.replace(//g, '');
                    if (transformedInput !== inputValue) {
                        ctrl.$setViewValue(transformedInput);
                        ctrl.$render();
                    }
                    return transformedInput;
                };

                ctrl.$parsers.unshift(validateNumber);
                ctrl.$parsers.push(validateNumber);
                attrs.$observe('notEmpty', function () {
                    validateNumber(ctrl.$viewValue);
                });
            }
        }
    }])
    .directive("onlyLetter", ['$parse', function($parse){
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {
                var validateNumber = function (inputValue) {
                    if (inputValue === undefined) {
                        return '';
                    }
                    var transformedInput = inputValue.replace(/[^a-zA-Z]/g, '');
                    if (transformedInput !== inputValue) {
                        ctrl.$setViewValue(transformedInput);
                        ctrl.$render();
                    }
                    return transformedInput;
                };

                ctrl.$parsers.unshift(validateNumber);
                ctrl.$parsers.push(validateNumber);
                attrs.$observe('notEmpty', function () {
                    validateNumber(ctrl.$viewValue);
                });
            }
        }
    }])
    .directive("onlyLetterNumber", ['$parse', function($parse){
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {
                var validateNumber = function (inputValue) {
                    if (inputValue === undefined) {
                        return '';
                    }
                    var transformedInput = inputValue.replace(/[^a-zA-Z0-9]/g, '');
                    if (transformedInput !== inputValue) {
                        ctrl.$setViewValue(transformedInput);
                        ctrl.$render();
                    }
                    return transformedInput;
                };

                ctrl.$parsers.unshift(validateNumber);
                ctrl.$parsers.push(validateNumber);
                attrs.$observe('notEmpty', function () {
                    validateNumber(ctrl.$viewValue);
                });
            }
        }
    }])
    .directive("onlyLetterNumberHyphen", ['$parse', 'Util', function($parse, Util){
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {
                var validateNumber = function (inputValue) {
                    if (inputValue === undefined) {
                        return '';
                    }
                    var transformedInput = inputValue.replace(/[^a-zA-Z-0-9\s-]/g, '');

                    if(transformedInput.charAt(0) === '-') {
                        transformedInput = Util.removeCharacter(transformedInput, 0);
                    }

                    if (transformedInput !== inputValue) {
                        ctrl.$setViewValue(transformedInput);
                        ctrl.$render();
                    }
                    return transformedInput;
                };

                ctrl.$parsers.unshift(validateNumber);
                ctrl.$parsers.push(validateNumber);
                attrs.$observe('notEmpty', function () {
                    validateNumber(ctrl.$viewValue);
                });
            }
        }
    }])
    .directive("letterNumberSpecialChar", ['$parse', function($parse){
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {
                var validateNumber = function (inputValue) {
                    if (inputValue === undefined) {
                        return '';
                    }
                    var transformedInput = inputValue.replace(/[^a-zA-Z0-9\sÑñ&\u00C0-\u024F#.-]/g, '');
                    if (transformedInput !== inputValue) {
                        ctrl.$setViewValue(transformedInput);
                        ctrl.$render();
                    }
                    return transformedInput;
                };

                ctrl.$parsers.unshift(validateNumber);
                ctrl.$parsers.push(validateNumber);
                attrs.$observe('notEmpty', function () {
                    validateNumber(ctrl.$viewValue);
                });
            }
        }
    }])
    .directive("onlyNumber", ['$parse', function($parse){
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {
                var validateNumber = function (inputValue) {
                    if (inputValue === undefined || inputValue === null) {
                        return '';
                    }
                    var inputValueAux = ""+ inputValue;
                    var transformedInput = inputValueAux.replace(/[^0-9]/g, '');

                    if(transformedInput.indexOf("0") === 0 && transformedInput.length>1) {
                        transformedInput = transformedInput.substring(1,transformedInput.length)
                    }

                    var f = transformedInput.indexOf("-");
                    var l = transformedInput.lastIndexOf("-");

                    if(f > 0) {
                        transformedInput = transformedInput.substring(0,transformedInput.length - 1)
                    }

                    if(l !== f) {
                        transformedInput = transformedInput.substring(0,l)
                    }

                    if (transformedInput !== inputValueAux) {
                        ctrl.$setViewValue(transformedInput);
                        ctrl.$render();
                    }

                    return transformedInput;
                };
                ctrl.$parsers.unshift(validateNumber);
                ctrl.$parsers.push(validateNumber);
                attrs.$observe('notEmpty', function () {
                    validateNumber(ctrl.$viewValue);
                });
            }
        }
    }])
    .directive("onlyNumberTime", ['$parse', function($parse){
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {
                var validateNumber = function (inputValue) {
                    if (inputValue === undefined) {
                        return '';
                    }
                    var inputValueAux = ""+ inputValue;
                    var transformedInput = inputValueAux.replace(/[^0-9:]/g, '');
                    if (transformedInput !== inputValueAux) {
                        ctrl.$setViewValue(transformedInput);
                        ctrl.$render();
                    }

                    return transformedInput;
                };

                ctrl.$parsers.unshift(validateNumber);
                ctrl.$parsers.push(validateNumber);
                attrs.$observe('notEmpty', function () {
                    validateNumber(ctrl.$viewValue);
                });
            }
        }
    }])
    .directive("onlyNumberFloat", ['Util', function(Util){
        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                isNegative: '='
            },
            link: function (scope, element, attrs, ctrl) {
                var validateNumber = function (inputValue) {
                    if (inputValue === undefined) {
                        return '';
                    }
                    var inputValueAux = ""+ inputValue;
                    var transformedInput = inputValueAux.replace(/[^0-9.\s-]/g, '');

                    if(transformedInput.indexOf(".") === 0) {
                        transformedInput = "0"+transformedInput
                    }

                    if (!isNegative) {
                        if(!Util.isANumber(transformedInput)) {
                            transformedInput = transformedInput.substring(0, (transformedInput.length - 1));
                        }
                    }

                    if (transformedInput !== inputValueAux) {
                        ctrl.$setViewValue(transformedInput);
                        ctrl.$render();
                    }

                    return transformedInput;
                };

                var scopeNegative = scope.isNegative;
                var isNegative = false;

                if (scopeNegative !== undefined) {
                    isNegative = scope.isNegative;
                }

                ctrl.$parsers.unshift(validateNumber);
                ctrl.$parsers.push(validateNumber);
                attrs.$observe('notEmpty', function () {
                    validateNumber(ctrl.$viewValue);
                });
            }
        }
    }])
    .directive("onlyEmail", ['$parse', 'Util', function($parse, Util){
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {
                var validateNumber = function (inputValue) {
                    if (inputValue === undefined) {
                        return '';
                    }

                    var transformedInput = inputValue.replace(/[^a-zA-Z0-9_.@+\s-]/g, '');
                    var inputCharAt = transformedInput.charAt(0);

                    if(inputCharAt === '.' || inputCharAt === '-' || inputCharAt === '+' || inputCharAt === '_') {
                        transformedInput = Util.removeCharacter(transformedInput, 0);
                    }

                    if (transformedInput !== inputValue) {
                        ctrl.$setViewValue(transformedInput);
                        ctrl.$render();
                    }

                    return transformedInput;
                };

                ctrl.$parsers.unshift(validateNumber);
                ctrl.$parsers.push(validateNumber);
                attrs.$observe('notEmpty', function () {
                    validateNumber(ctrl.$viewValue);
                });
            }
        }
    }])
    .directive("numberSlash", ['$parse', function($parse){
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {
                var validateNumber = function (inputValue) {
                    if (inputValue === undefined) {
                        return '';
                    }
                    var inputValueAux = ""+ inputValue;
                    var transformedInput = inputValueAux.replace(/[^0-9/]/g, '');
                    if (transformedInput !== inputValue) {
                        ctrl.$setViewValue(transformedInput);
                        ctrl.$render();
                    }
                    return transformedInput;
                };

                ctrl.$parsers.unshift(validateNumber);
                //ctrl.$parsers.push(validateNumber);
                attrs.$observe('notEmpty', function () {
                    validateNumber(ctrl.$viewValue);
                });
            }
        }
    }])
    .directive("letterNumberSpace", ['$parse', function($parse){
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {
                var validateNumber = function (inputValue) {
                    if (inputValue === undefined) {
                        return '';
                    }
                    var transformedInput = inputValue.replace(/[^a-zA-Z0-9\s]/g, '');
                    if (transformedInput !== inputValue) {
                        ctrl.$setViewValue(transformedInput);
                        ctrl.$render();
                    }
                    return transformedInput;
                };

                ctrl.$parsers.unshift(validateNumber);
                ctrl.$parsers.push(validateNumber);
                attrs.$observe('notEmpty', function () {
                    validateNumber(ctrl.$viewValue);
                });
            }
        }
    }])
    .directive("keyPressedBarra", ['$parse', function($parse){
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {
                element.bind("keydown keypress", function(event) {
                    var keyCode = event.which || event.keyCode;

                    // pressed space white
                    if (keyCode === 32) {
                        event.preventDefault();
                    }
                });            }
        }
    }])
    .directive('disallowSpaces', function () {
        return {
            restrict: 'A',

            link: function($scope, $element) {
                $element.bind('input', function() {
                    $(this).val($(this).val().replace(/ /g, ''));
                });
            }
        };
    })
    .directive("nDecimals", function ($filter) {
        return {
            restrict: 'A',
            link: function (scope, element, attr) {
                element.on('input', function (e) {
                    var maxDecimal = Number(element.attr('n-Decimals'));
                    var sal = element.val();
                    var parts;
                    if (sal.indexOf(".") !== -1) {
                        parts = sal.split(".");
                        if (parts[1].length > maxDecimal) {
                            element.val(sal.substr(0, sal.length - 1));
                        }
                    }
                });

                element.on('change', function (e) {
                    var maxDecimal = Number(element.attr('n-Decimals'));
                    var sal = element.val();
                    var parts;
                    if (sal.indexOf(".") !== -1) {
                        parts = sal.split(".");
                        if (parts[1].length > maxDecimal) {
                            element.val(sal.substr(0, sal.length - 1));
                        }
                    }
                });
                // destroy event.
                scope.$on('$destroy', function () {
                    element.off('input');
                    element.off('change');
                });
            }
        };
    });

function isEmpty(value) {
    return angular.isUndefined(value) || value === '' || value === null || value !== value;
}
